<template>
    <div class="container-fluid">
        <div v-if="placingOrder">
            <div class="row bg-white">
                <div class="col-sm-12">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 my-6 text-center">
                                <h1>{{$t('components.checkout.in-progress.title')}}</h1>
                                <figure class="text-center pt-6">
                                    <img class="fa-spin" src="/img/loading.png" alt="in-progress" width="128" height="128">
                                </figure>
                                <p>{{$t('components.checkout.in-progress.text')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row bg-white" v-if="thankYou">
                <div class="col-sm-12">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 my-6 text-center">
                                <h1>{{$t('components.checkout.thanks.title')}}</h1>
                                <figure class="text-center pt-6">
                                    <img src="/img/check.png" alt="thank-you" width="128" height="128">
                                </figure>
                                <p>{{$t('components.checkout.thanks.text')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-sm-12">
                    <h1>{{$t('components.checkout.title')}}</h1>
                    <div class="row">
                        <div class="wos__content container-fluid bg-white shadow">
                            <div class="row m-5">
                                <div class="col-md-4 order-md-2 mb-4">
                                    <h4 class="d-flex justify-content-between align-items-center mb-3">
                                        <span class="text-muted">{{$t('components.cart.title')}}</span>
                                        <span class="badge badge-secondary badge-pill">{{countCartItems}}</span>
                                    </h4>
                                    <ul class="list-group mb-3">

                                        <div v-for="(item, index) in cartItems" :key="index">
                                            <li class="list-group-item d-flex justify-content-between lh-condensed">
                                                <div>
                                                    <h6 class="my-0">{{item.name | cut}}</h6>
                                                    <small class="text-muted">
                                                        {{item.catalogNo}}
                                                    </small>
                                                </div>
                                                <span class="text-muted">{{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}</span>
                                            </li>
                                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                                v-for="(subItem, subIndex) in item.children" :key="subIndex">
                                                <div>
                                                    <h6 class="my-0 ml-3"><i class="fa fa-plus"></i> {{subItem.name | cut}}</h6>
                                                    <small class="text-muted ml-3">
                                                        {{subItem.catalogNo}}
                                                    </small>
                                                </div>
                                                <span class="text-muted">{{subItem.price.unitPrice * subItem.quantity | toPrice(subItem.price.currency, subItem.price.vat)}}</span>
                                            </li>
                                        </div>

                                        <li class="list-group-item d-flex justify-content-between">
                                            <span>{{$t('components.cart.totalPrice') | toUpper}}</span>
                                            <strong>{{total | toPrice(currency, hasVat)}}</strong>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-8 order-md-1">
                                    <h4 class="mb-3">{{$t('components.billing.title')}}</h4>
                                    <div class="row">
                                        <div class="col-md-10 mb-3">
                                            <label>{{$t('components.billing.company')}}</label>
                                            <input type="text" class="form-control" disabled
                                                   :value="billingInfo.companyName">
                                        </div>
                                        <div class="col-md-2 mb-3">
                                            <label>{{$t('components.billing.country')}}</label>
                                            <input type="text" class="form-control text-center" disabled
                                                   :value="billingInfo.countryCode">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4 mb-3">
                                            <label>{{$t('components.billing.zip')}}</label>
                                            <input type="text" class="form-control" disabled
                                                   :value="billingInfo.zipCode">
                                        </div>
                                        <div class="col-md-8 mb-3">
                                            <label>{{$t('components.billing.city')}}</label>
                                            <input type="text" class="form-control" disabled
                                                   :value="billingInfo.city">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label>{{$t('components.billing.address')}}</label>
                                            <input type="text" class="form-control" disabled
                                                   :value="billingAddress">
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label>{{$t('components.billing.vatNo')}}</label>
                                            <input type="text" class="form-control" disabled
                                                   :value="billingInfo.vatNo">
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <label>{{$t('components.checkout.email')}}</label>
                                        <input type="text" class="form-control" disabled
                                               :value="accountData.email">
                                    </div>

                                    <hr class="mb-4">

                                    <div class="mb-3">
                                        <label>{{$t('components.checkout.notes')}}</label>
                                        <textarea type="text" class="form-control"
                                                  rows="3"
                                                  style="resize: none"
                                                  :placeholder="$t('components.checkout.notesPlaceholder')"
                                                  v-model="checkout.notes"></textarea>
                                    </div>

                                    <hr class="mb-4">
                                    <h4 class="mb-3">{{$t('components.checkout.payments.title')}}</h4>

                                    <div class="d-flex my-3">
                                        <button v-for="item in availablePaymentMethods" :key="item.key"
                                                :class="['btn btn mr-10', selectedPaymentMethod === item.key
                                            ? 'btn-wellis-gold text-wellis-white' : 'btn-outline-wellis-black']"
                                                @click="setPaymentMethod(item.key)">
                                            {{$t('components.checkout.payments')[item.key]}}
                                        </button>
                                    </div>
                                    <div v-if="selectedPaymentMethod !== null">
                                        <hr class="mb-4">
                                        <h4 class="mb-3">Shipping</h4>

                                        <div class="d-flex my-3">
                                            <button v-for="item in availableShippingMethods" :key="item.key"
                                                    :class="['btn btn mr-10', selectedShippingMethod === item.key
                                            ? 'btn-wellis-gold text-wellis-white' : 'btn-outline-wellis-black']"
                                                    @click="setShippingMethod(item.key)">
                                                {{$t('components.checkout.shippingMethods')[item.key]}}
                                            </button>
                                        </div>

                                        <div v-if="selectedShippingMethod !== null">
                                            <hr class="mb-4">
                                            <h4 class="mb-3">Address</h4>
                                            <div class="d-flex my-3">
                                                <button :class="['btn btn mr-10',
                                            temporaryShippingAddress
                                            ? 'btn-wellis-gold text-wellis-white' : 'btn-outline-wellis-black']"
                                                        @click="setShippingAddressTemp(true)">
                                                    {{$t('components.checkout.shippingAddress.temp.title')}}
                                                </button>

                                                <button :class="['btn btn mr-10',
                                            !temporaryShippingAddress
                                            ? 'btn-wellis-gold text-wellis-white' : 'btn-outline-wellis-black']"
                                                        @click="setShippingAddressTemp(false)">
                                                    {{$t('components.checkout.shippingAddress.exists.title')}}
                                                </button>
                                            </div>

                                            <div class="row mt-5" v-if="!temporaryShippingAddress">
                                                <div class="col-sm-12 mb-3">
                                                    <label>{{$t('components.checkout.shippingAddress.exists.select')}}</label>
                                                    <select class="form-control" v-model="checkout.shippingAddress.addressId">
                                                        <option v-for="(item, index) in shippingAddresses" :key="index"
                                                                :value="item.addressId">
                                                            {{`${item.zipCode} ${item.city} ${item.primaryAddressLine} ${item.secondaryAddressLine || ''}`}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row mt-5" v-else>
                                                <div class="col-sm-12" v-if="checkout.shippingAddress.temporaryAddress.zip !== null">
                                                    <div class="temp-shipping-string noselect">{{temporaryShippingAddressString}}</div>
                                                </div>
                                                <div class="col-sm-12" v-else>
                                                    <div class="row">
                                                        <div class="col-sm-12 mb-3">
                                                            <input type="text" class="form-control"
                                                                   autocomplete="off"
                                                                   :placeholder="$t('components.billing.zip')"
                                                                   v-model="tempForm.zip">
                                                        </div>
                                                        <div class="col-sm-12 mb-3">
                                                            <input type="text" class="form-control"
                                                                   autocomplete="off"
                                                                   :placeholder="$t('components.billing.city')"
                                                                   v-model="tempForm.city">
                                                        </div>
                                                        <div class="col-sm-12 mb-3">
                                                            <input type="text" class="form-control"
                                                                   autocomplete="off"
                                                                   :placeholder="$t('components.checkout.shippingAddress.temp.address1')"
                                                                   v-model="tempForm.address1">
                                                        </div>
                                                        <div class="col-sm-12 mb-3">
                                                            <input type="text" class="form-control"
                                                                   autocomplete="off"
                                                                   :placeholder="$t('components.checkout.shippingAddress.temp.address2')"
                                                                   v-model="tempForm.address2">
                                                        </div>
                                                        <div class="col-sm-12 mb-3">
                                                            <button class="w-100 btn btn-wellis-black text-uppercase" @click="finalizeTemporaryAddress">{{$t('btnSave')}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="hasShippingServices" class="mt-5">
                                        <p>{{$t('components.checkout.select-shipping-service')}}</p>
                                        <div class="row">
                                            <div v-for="(item, index) in shippingServices" :key="index" class="col-sm-12 col-md">
                                                <button :class="['btn mr-10', selectedShippingService === index
                                            ? 'btn-wellis-gold text-wellis-white' : 'btn-outline-wellis-black']"
                                                        @click="setShippingService(index)">
                                                    {{item.name}}
                                                    <br>
                                                    {{item.price.unitPrice | toPrice(item.price.currency, item.price.vat)}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="orderReady">
                                        <hr class="mb-4">
                                        <button class="btn btn-primary btn-lg btn-block" type="button" @click="performCheckout">{{$t('components.checkout.btnPlaceOrder')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckoutApiService from "../../../api/checkout.api";
import {__clone, empty} from "../../../helpers";
import {EVENT_CART_COUNT_UPDATE, EVENT_LANG_CHANGE} from "@/core/constants";

export default {
    name: "Checkout",
    created() {
        this.fetch();

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.fetch();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },


    data() {
        return {
            billing: {},
            account: {},
            shipping: [],
            paymentMethods: [],
            shippingMethods: [],
            shippingServices: false,
            cart: [],

            tempForm: {
                zip: null,
                city: null,
                address1: null,
                address2: null
            },

            checkout: {
                selectedPaymentMethod: null,
                selectedShippingMethod: null,
                shippingAddress: __clone(this.defaultShippingAddressObj()),
                shippingService: null,
                notes: null
            },

            orderInProgress: false,
            orderComplete: false
        }
    },

    methods: {
        defaultShippingAddressObj() {
            return {
                addressId: null,
                temporary: false,
                temporaryAddress: {
                    zip: null,
                    city: null,
                    address1: null,
                    address2: null
                },
            };
        },


        fetch() {
            let loader = this.$loading.show();
            CheckoutApiService.getPreviewData()
                .then(response => {
                    this.billing = response.data.billing;
                    this.shipping = response.data.shipping;
                    this.account = response.data.account;
                    this.paymentMethods = response.data.paymentMethods;
                    this.cart = response.data.cart;

                    if(this.availablePaymentMethods.length === 1) {
                        this.setPaymentMethod(this.availablePaymentMethods[0].key);
                    }
                })
                .catch(() => {
                    this.$router.push({
                        name: 'app.cart'
                    });
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        setPaymentMethod(method) {
            this.checkout.selectedShippingMethod = null;
            this.shippingServices = false;
            this.checkout.shippingService = null;
            if (this.checkout.selectedPaymentMethod === method) {
                this.checkout.selectedPaymentMethod = null;
            } else {
                let loader = this.$loading.show();
                CheckoutApiService.getShippingMethods(method)
                    .then(response => {
                        this.checkout.selectedPaymentMethod = method;
                        this.shippingMethods = response.data;

                        if(this.availableShippingMethods.length === 1) {
                            this.setShippingMethod(this.availableShippingMethods[0].key);
                        }
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            }
        },

        setShippingMethod(method) {
            this.checkout.shippingAddress = __clone(this.defaultShippingAddressObj());
            if (this.checkout.selectedShippingMethod === method) {
                this.checkout.selectedShippingMethod = null;
            } else {
                this.checkout.selectedShippingMethod = method;
            }
            this.shippingServices = false;
            this.checkout.shippingService = null;
        },

        setShippingAddressTemp(value) {
            this.checkout.shippingAddress = __clone(this.defaultShippingAddressObj());
            this.checkout.shippingAddress.temporary = value;
            this.shippingServices = false;
            this.checkout.shippingService = null;
        },

        validateShippingAddress(data) {
            return new Promise((resolve, reject) => {
                const errors = [];

                if (this.checkout.shippingAddress.temporary) {
                    if (empty(data.zip)) {
                        errors.push(this.$t('validation.required', {field: this.$t('components.billing.zip')}));
                    } else {
                        if (isNaN(data.zip)) {
                            errors.push(this.$t('validation.numeric', {field: this.$t('components.billing.zip')}));
                        }
                    }

                    if (empty(data.city)) {
                        errors.push(this.$t('validation.required', {field: this.$t('components.billing.city')}));
                    }

                    if (empty(data.address1)) {
                        errors.push(this.$t('validation.required', {field: this.$t('components.billing.address1')}));
                    } else {
                        if (data.address1.length > 35) {
                            errors.push(this.$t('validation.maxlength', {field: this.$t('components.checkout.shippingAddress.temp.address1'), num: 35}));
                        }
                    }

                    if (!empty(data.address2)) {
                        if (data.address2.length > 35) {
                            errors.push(this.$t('validation.maxlength', {field: this.$t('components.checkout.shippingAddress.temp.address2'), num: 35}));
                        }
                    }
                }

                if (errors.length > 0) {
                    return reject(errors);
                }

                return resolve(data);
            });
        },

        fetchShippingServices() {
            let loader = this.$loading.show();
            this.shippingServices = [];

            CheckoutApiService.getShippingServices(this.checkout.selectedPaymentMethod, this.checkout.selectedShippingMethod, this.checkout.shippingAddress)
                .then(response => {
                    if (this.account.custGroup === 'NAGYKER') {
                        let offers = Object.values(response.data.offers);
                        let offer = null;
                        if (offers.length > 0) {
                            offer = __clone(offers[0]);
                            offer.price.factoryPrice = 0;
                            offer.price.unitPrice = 0;
                            offers.forEach(item => {
                                offer.price.factoryPrice += item.price.factoryPrice;
                                offer.price.unitPrice += item.price.unitPrice;
                            });
                            offer.name = this.$t('components.checkout.transportation-fee');
                            offer.code = 'LOCAL';
                            this.shippingServices = [offer];
                        }
                    } else {
                        this.shippingServices = response.data.offers;
                    }
                })
                .catch(() => this.shippingServices = false)
                .finally(() => {
                    loader.hide();
                    loader = null;
                })
        },

        finalizeTemporaryAddress() {
            this.validateShippingAddress(this.tempForm)
                .then(() => {
                    this.checkout.shippingAddress.temporaryAddress = __clone(this.tempForm);
                    this.tempForm = {
                        zip: null,
                        city: null,
                        address1: null,
                        address2: null
                    };
                })
                .catch(errors => {
                    this.$swal.fire({
                        icon: "error",
                        html: errors.join('<br>')
                    });
                });
        },

        setShippingService(index) {
            if (this.checkout.shippingService === index) {
                this.checkout.shippingService = null;
            } else {
                this.checkout.shippingService = index;
            }
        },

        performCheckout() {
            this.validateShippingAddress(this.checkout.shippingAddress.temporaryAddress)
                .then(() => {
                    this.orderInProgress = true;
                    document.body.classList.add('main-loading');
                    document.body.classList.add('noselect');
                    let data = this.checkout;
                    if (data.shippingService) {
                        data.shippingService = this.shippingServices[data.shippingService].code;
                    }
                    CheckoutApiService.checkout(this.checkout)
                        .then(() => {
                            this.orderComplete = true;
                            this.$eventBus.$emit(EVENT_CART_COUNT_UPDATE, 0);
                        })
                        .catch(() => {
                            this.$swal.fire({
                                icon: "error",
                            });
                        })
                        .finally(() => {
                            this.orderInProgress = false;
                            document.body.classList.remove('main-loading');
                            document.body.classList.remove('noselect');
                        });
                })
                .catch(errors => {
                    this.$swal.fire({
                        icon: "error",
                        html: errors.join('<br>')
                    });
                });
        }
    },

    computed: {
        countCartItems() {
            let i = this.cart.length;

            this.cart.map(item => {
                i += item.children.length;
            });

            return i;
        },

        cartItems() {
            return this.cart;
        },

        billingInfo() {
            return this.billing;
        },

        availablePaymentMethods() {
            let methods = [];
            Object.keys(this.paymentMethods).map(item => {
                if (this.paymentMethods[item] === true) {
                    methods.push({
                        key: item
                    });
                }
            });

            return methods;
        },

        availableShippingMethods() {
            let methods = [];
            Object.keys(this.shippingMethods).map(item => {
                if (this.shippingMethods[item] === true) {
                    methods.push({
                        key: item
                    });
                }
            });

            return methods;
        },

        shippingAddresses() {
            return this.shipping;
        },

        accountData() {
            return this.account;
        },

        total() {
            let total = 0;
            this.cart.map(item => {
                total += item.price.unitPrice * item.quantity;
                item.children.map(x => total += x.price.unitPrice * x.quantity);
            });

            return total;
        },

        currency() {
            if (this.cart.length > 0) {
                return this.cart[0].price.currency || 'N/A';
            }

            return 'HUF';
        },

        hasVat() {
            if (this.cart.length > 0) {
                return this.cart[0].price.vat || false;
            }

            return false;
        },

        billingAddress() {
            return `${this.billing.streetName} ${this.billing.streetSuffix} `
                + `${this.billing.houseNo}`;
        },

        selectedPaymentMethod() {
            return this.checkout.selectedPaymentMethod;
        },

        selectedShippingMethod() {
            return this.checkout.selectedShippingMethod;
        },

        temporaryShippingAddress() {
            return this.checkout.shippingAddress.temporary;
        },

        temporaryShippingAddressString() {
            return `${this.checkout.shippingAddress.temporaryAddress.zip} ${this.checkout.shippingAddress.temporaryAddress.city}`
                + ` ${this.checkout.shippingAddress.temporaryAddress.address1} ${this.checkout.shippingAddress.temporaryAddress.address2 || ''}`;
        },

        isTemporaryAddressFilled() {
            return this.checkout.shippingAddress.temporaryAddress.zip !== null
                && this.checkout.shippingAddress.temporaryAddress.city !== null
                && this.checkout.shippingAddress.temporaryAddress.address1 !== null;
        },

        orderReady() {
            let a = !empty(this.checkout.selectedPaymentMethod)
                && !empty(this.checkout.selectedShippingMethod)
                && (this.checkout.shippingAddress.temporary
                    ? (!empty(this.checkout.shippingAddress.temporaryAddress.zip)
                        && !empty(this.checkout.shippingAddress.temporaryAddress.city)
                        && !empty(this.checkout.shippingAddress.temporaryAddress.address1)
                    )
                    : !empty(this.checkout.shippingAddress.addressId));

            let b = false;
            if (this.account.custGroup === 'NAGYKER') {
                if (this.checkout.selectedPaymentMethod === 'CARD-ONLINE' && this.checkout.shippingAddress.temporary) {
                    b = this.shippingServices.length > 0 && !empty(this.checkout.shippingService);
                } else {
                    b = true;
                }
            } else {
                if (this.checkout.selectedPaymentMethod === 'CARD-ONLINE') {
                    b = this.shippingServices.length > 0 && !empty(this.checkout.shippingService);
                } else {
                    b = true;
                }
            }

            return a && b;
        },

        thankYou() {
            return this.orderComplete === true;
        },

        placingOrder() {
            return this.orderInProgress === true;
        },

        hasShippingServices() {
            return this.shippingServices instanceof Array && this.shippingServices.length > 0;
        },

        selectedShippingService() {
            return this.checkout.shippingService;
        },
    },

    watch: {
        'shippingAddressReady': function (value) {
            if (value) {
                if (this.checkout.selectedPaymentMethod === 'CARD-ONLINE') {
                    this.fetchShippingServices();
                }
            }
        },

        'checkout.shippingAddress.addressId': function (value) {
            this.shippingServices = false;
            this.checkout.shippingService = null;
            if (this.account.custGroup !== 'NAGYKER' && this.checkout.selectedPaymentMethod === 'CARD-ONLINE' && value) {
                this.fetchShippingServices();
            }
        },

        'checkout.shippingAddress.temporaryAddress': {
            deep: true,
            handler: function () {
                if (this.isTemporaryAddressFilled) {
                    this.shippingServices = false;
                    this.checkout.shippingService = null;
                    if (this.account.custGroup === 'NAGYKER') {
                        if (this.checkout.selectedPaymentMethod === 'CARD-ONLINE' && this.checkout.shippingAddress.temporary) {
                            this.fetchShippingServices();
                        }
                    } else {
                        if (this.checkout.selectedPaymentMethod === 'CARD-ONLINE') {
                            this.fetchShippingServices();
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.temp-shipping-string {
    color: #333132;
    border: 1px solid #333132;
    padding: 15px;
}
</style>
